import { Directive, Input, HostListener, OnInit, ElementRef, Inject } from '@angular/core';

@Directive({
  selector: '[abs-accessibility-click]'
})
export class AbsAccessibilityClickDirective implements OnInit {
  @Input('abs-accessibility-click') accessibiltyValue : string;
  accessibilityValueArray : string[];
  constructor(@Inject(ElementRef) private element : ElementRef){}
  ngOnInit(){
    if(this.accessibiltyValue){
      this.accessibilityValueArray = this.accessibiltyValue.split(',');
    }
  }
  @HostListener('keyup', ['$event'])
  onEvent(event) {
    var keyCodeCondition = function (that) {
      var flag = false;
      if (!(event.keyCode)) {
        if (event.which) {
          event.keyCode = event.which; 
        } else if (event.charCode) {
          event.keyCode = event.charCode;
        }
      }
      if ((event.keyCode && that.accessibilityValueArray.indexOf(event.keyCode.toString()) > -1)) {
        flag = true;
      }
      return flag;
    };
    const that = this;
    if (this.accessibilityValueArray.length > 0 && keyCodeCondition(that)) {
      this.element.nativeElement.click();
      event.preventDefault();
    }
    
  }
}